// Auto-generated from environment by scripts/sync-env.mjs — do not edit manually.
export const runtimeEnv = {
  apiUrl: "https://lumina-api.inventlabs.tech/graphql",
} as const;
